import React from 'react';
import { Link } from 'react-router-dom';
import type { TranslationKeys } from '@/core/i18n/translations';

export interface SiteFooterProps {
  t: TranslationKeys;
}

export function SiteFooter({ t }: SiteFooterProps) {
  const year = new Date().getFullYear();
  return (
    <footer className="text-center mt-12 py-6 border-t border-blue-200 dark:border-slate-800 text-slate-500 dark:text-slate-400">
      <p>{t.footerCopyright.replace('{year}', String(year))}</p>
      {t.footerTagline ? <p className="mt-2 text-sm max-w-2xl mx-auto leading-snug">{t.footerTagline}</p> : null}
      <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mt-2">
        <Link
          to="/terms-of-service"
          className="font-medium text-orange-800 underline underline-offset-2 decoration-orange-800 hover:text-orange-900 dark:text-orange-200 dark:decoration-orange-200 dark:hover:text-orange-100"
        >
          {t.footerTermsOfService}
        </Link>
        <Link
          to="/privacy-policy"
          className="font-medium text-orange-800 underline underline-offset-2 decoration-orange-800 hover:text-orange-900 dark:text-orange-200 dark:decoration-orange-200 dark:hover:text-orange-100"
        >
          {t.footerPrivacyPolicy}
        </Link>
        <a
          href="mailto:support@prompt2train.fit"
          className="font-medium text-orange-800 underline underline-offset-2 decoration-orange-800 hover:text-orange-900 dark:text-orange-200 dark:decoration-orange-200 dark:hover:text-orange-100"
        >
          support@prompt2train.fit
        </a>
      </div>
    </footer>
  );
}
